import { captureException} from "@sentry/react";

import config from "../utils/config";
import toastService from './toastService';

const log = (error: Error): void => {
	if (config.enableSentry && process.env.NODE_ENV === 'production') {
		captureException(error);
	}

	const message = (error as  any)?.response?.data?.message ?? error.message;
	toastService.error(message);
};

const logger = { log };
export default logger;
